import axios from "axios";

/*****
 *  Balances Request
 */

export const fetchBalanceReq = businessId => {
    return axios.get(`/wallets/${businessId}`);
}
export const fetchBanksReq = _ => {
    return axios.get(`/banks?currency=ngn`);
}

export const resolveNubanReq = ({nuban, code}) => {
  return axios.get(`/bank/validate?nuban=${nuban}&code=${code}&currency=ngn`);
}

export const generateOTPReq = businessId => {
    return axios.post(`/business/${businessId}/banks/generate-code`, {});
}

export const fetchPayoutsReq = businessId => {
    return axios.get(`/payout-account?businessId=${businessId}`);
}

export const addPayoutAccountReq = data => {
    const {businessId} = data;
    return axios.post(`/business/${businessId}/banks/confirm-code`, data);
}

export const withdrawReq = (walletId, data) => {
    return axios.post(`/business/${walletId}/payout`, data);
}

export const setDefaultPayoutAccountReq = data => {
    return axios.post(`/payout-account/active`, data);
}

export const exportBalancesReq = (businessId, email, start, end) => {
    return axios.get(`/wallets/exports?businessId=${businessId}${email ? `&email=${encodeURI(email)}` : ""}${start ? `&start=${start}` : ""}${end ? `&end=${end}` : ""}`);
}

export const deletePayoutAccountReq = data => {
    return axios.post(`/payout-account/remove`, data);
}

export const fetchWalletHistoryReq = (businessId, walletId, type) => {
    if (type !== "commission") {
        return axios.get(`/business/${businessId}/activity-history?walletId=${walletId}`);
    }
    return axios.get(`/business/${walletId}/payouts`);
}